module.exports = __webpack_public_path__ + "static/img/moneyb.c6c8dfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moneyb.jpg
// module id = VQqB
// module chunks = 73